export const setUpdatedBy = (object, userName) => {
    if (object) return {...object, updatedBy: userName}
    return object
}